// Destek — kimde sıra olduğu görünür, sohbet akışı, kategori/öncelik netleştirilmiş
import { api } from '../api';
import { state, isAdmin, navigate } from '../app';
import { esc, $, $$, setHTML, statusBadge, statusLabel, timeAgo, formatDate, icons } from '../helpers';
import { openFlow, FlowStep } from '../shell';
import { toast, openModal, closeModal, setBreadcrumb, skeletonTable } from '../ui';

type TFilter = 'open' | 'mine' | 'all' | 'closed';
let tFilter: TFilter = 'open';
let tQuery = '';

const CATEGORIES: [string, string, string][] = [
  ['technical', 'Teknik sorun', 'Site, uygulama veya erişim sorunu'],
  ['billing', 'Fatura / ödeme', 'Fatura, tahsilat veya sözleşme sorusu'],
  ['general', 'Yeni talep', 'Yeni iş, revizyon veya bilgi talebi'],
  ['other', 'Diğer', 'Yukarıdakilere uymuyorsa'],
];
const PRIORITIES: [string, string][] = [
  ['normal', 'Normal — işimi aksatmıyor'],
  ['high', 'Yüksek — işimi yavaşlatıyor'],
  ['urgent', 'Acil — çalışamıyorum'],
];

export async function renderTickets() {
  const content = $('#content')!;
  setBreadcrumb([{ label: 'Panel', href: '/dashboard' }, { label: 'Destek' }]);
  setHTML(content, skeletonTable(6, 5));
  try {
    const data = await api.get('/tickets');
    const all: any[] = data.tickets || [];
    const open = all.filter(t => t.status === 'open' || t.status === 'in_progress');
    const mine = all.filter(t => t.awaiting === (isAdmin() ? 'admin' : 'customer'));

    setHTML(content, `<div>
      <div class="page-header"><div><h1>Destek</h1><p class="page-sub">${open.length} açık talep${mine.length ? ' · ' + mine.length + ' sizde' : ''}</p></div>
        <div class="page-header-actions"><button class="btn btn-primary" id="new-ticket-btn"><i data-lucide="plus"></i> Yeni talep</button></div></div>
      ${!isAdmin() ? '<p class="text-muted" style="font-size:.88rem;margin:-4px 0 12px">Talebinizi buradan iletin. Yanıtlar bu sayfada görünür; e-posta beklemenize gerek yok.</p>' : ''}
      <div class="list-tools"><div class="search-input-wrapper"><i data-lucide="search"></i><input type="search" id="tk-search" placeholder="Talep no, konu, müşteri…" autocomplete="off"></div></div>
      <div class="filters-bar" id="tk-filters">
        ${([['open', 'Açık', open.length], ['mine', isAdmin() ? 'Yanıt bekleyen' : 'Sizde', mine.length], ['closed', 'Kapanan', all.filter(t => t.status === 'resolved' || t.status === 'closed').length], ['all', 'Tümü', all.length]] as [TFilter, string, number][])
          .map(([f, l, n]) => `<button class="filter-chip${tFilter === f ? ' active' : ''}" data-f="${f}">${l} <span class="chip-count">${n}</span></button>`).join('')}
      </div>
      <div id="tk-list"></div>
    </div>`);
    icons();

    const draw = () => {
      const q = tQuery.toLowerCase();
      const rows = all.filter(t => {
        if (q && ![t.ticket_number, t.subject, t.client_name, t.client_company, t.last_message].filter(Boolean).join(' ').toLowerCase().includes(q)) return false;
        switch (tFilter) {
          case 'open': return t.status === 'open' || t.status === 'in_progress';
          case 'mine': return t.awaiting === (isAdmin() ? 'admin' : 'customer');
          case 'closed': return t.status === 'resolved' || t.status === 'closed';
          default: return true;
        }
      });
      const el = $('#tk-list')!;
      if (!rows.length) { setHTML(el, '<div class="empty-state"><i data-lucide="life-buoy"></i><p>Talep yok</p></div>'); icons(); return; }
      setHTML(el, `<div class="client-list">${rows.map(t => {
        const waitingUs = t.awaiting === (isAdmin() ? 'admin' : 'customer');
        return `<a href="/tickets/${t.id}" class="client-row${waitingUs ? ' row-flag' : ''}">
          <div class="client-main">
            <div class="client-title">${esc(t.subject)}</div>
            <div class="client-sub"><span class="font-mono">${esc(t.ticket_number)}</span>${isAdmin() && t.client_name ? ' · ' + esc(t.client_company || t.client_name) : ''}</div>
            <div class="client-meta">${t.last_message ? esc(String(t.last_message).slice(0, 90)) + (String(t.last_message).length > 90 ? '…' : '') : ''}</div>
            <div class="client-chips">${statusBadge(t.status)}${t.priority === 'urgent' ? '<span class="chip chip-danger">Acil</span>' : t.priority === 'high' ? '<span class="chip chip-warn">Yüksek</span>' : ''}<span class="chip chip-muted">${esc(statusLabel(t.category))}</span>${waitingUs ? `<span class="chip chip-info">${isAdmin() ? 'Yanıt bekliyor' : 'Sizden yanıt bekleniyor'}</span>` : ''}</div>
          </div>
          <div class="client-fin"><span class="amt-sub">${timeAgo(t.last_message_at || t.updated_at)}</span><span class="amt-sub">${t.reply_count || 0} mesaj</span></div>
          <i data-lucide="chevron-right" class="client-arrow"></i>
        </a>`;
      }).join('')}</div>`);
      icons();
    };
    draw();

    $$('#tk-filters .filter-chip').forEach(b => b.addEventListener('click', () => {
      tFilter = b.getAttribute('data-f') as TFilter;
      $$('#tk-filters .filter-chip').forEach(x => x.classList.toggle('active', x === b));
      draw();
    }));
    let t: any;
    (document.getElementById('tk-search') as HTMLInputElement).addEventListener('input', (e) => {
      clearTimeout(t); t = setTimeout(() => { tQuery = (e.target as HTMLInputElement).value.trim(); draw(); }, 150);
    });
    document.getElementById('new-ticket-btn')?.addEventListener('click', openNewTicketModal);
  } catch (err: any) { toast(err.message, 'error'); }
}

async function openNewTicketModal() {
  // Katmanlı akış: her adım ekrana sığar, uzun form kaydırılmaz.
  let clients: any[] = [];
  if (isAdmin()) {
    try { clients = ((await api.get('/clients')).clients || []).filter((c: any) => c.is_active); } catch { /* yoksay */ }
  }

  const draft: any = { client_id: '', category: '', subject: '', content: '', priority: 'normal' };
  let attach: { name: string; data: string } | null = null;

  const steps: FlowStep[] = [];

  if (isAdmin()) {
    steps.push({
      title: 'Müşteri',
      body: '<h2>Hangi müşteri için?</h2><p class="layer-lead">Talep bu müşterinin hesabına açılacak.</p>'
        + '<div class="ios-list">' + clients.map((c: any) =>
          '<button class="ios-row" data-client="' + esc(c.id) + '"><span class="ios-row-main"><span class="ios-row-title">'
          + esc(c.company || c.name) + '</span></span><span class="ios-row-value"><i data-lucide="chevron-right"></i></span></button>').join('')
        + '</div>',
      onMount: (root, go) => {
        root.querySelectorAll('[data-client]').forEach(b => b.addEventListener('click', () => {
          draft.client_id = b.getAttribute('data-client');
          go(1);
        }));
      },
    });
  }

  const catStep = steps.length;
  steps.push({
    title: 'Konu',
    body: '<h2>Konu nedir?</h2><p class="layer-lead">Size en hızlı şekilde dönebilmemiz için seçin.</p>'
      + '<div class="ios-list">' + CATEGORIES.map(([k, l, d]) =>
        '<button class="ios-row" data-cat="' + esc(k) + '"><span class="ios-row-main">'
        + '<span class="ios-row-title">' + esc(l) + '</span>'
        + '<span class="ios-row-sub">' + esc(d) + '</span></span>'
        + '<span class="ios-row-value"><i data-lucide="chevron-right"></i></span></button>').join('')
      + '</div>',
    onMount: (root, go) => {
      root.querySelectorAll('[data-cat]').forEach(b => b.addEventListener('click', () => {
        draft.category = b.getAttribute('data-cat');
        go(catStep + 1);
      }));
    },
  });

  steps.push({
    title: 'Detay',
    primaryLabel: 'Devam',
    body: '<h2>Ne oldu?</h2><p class="layer-lead">Ne kadar ayrıntı verirseniz o kadar hızlı çözeriz.</p>'
      + '<div class="form-group"><label for="tk-subject">Başlık</label>'
      + '<input type="text" id="tk-subject" maxlength="200" placeholder="Örn. İletişim formu mail göndermiyor"></div>'
      + '<div class="form-group"><label for="tk-content">Açıklama</label>'
      + '<textarea id="tk-content" rows="6" maxlength="5000" placeholder="Ne yapmaya çalıştınız, ne oldu, ne bekliyordunuz? Varsa hata mesajını ve adresi yazın."></textarea></div>',
    onMount: (root) => {
      (root.querySelector('#tk-subject') as unknown as HTMLInputElement).value = draft.subject;
      (root.querySelector('#tk-content') as unknown as HTMLTextAreaElement).value = draft.content;
    },
    onPrimary: (root, go) => {
      draft.subject = (root.querySelector('#tk-subject') as unknown as HTMLInputElement).value.trim();
      draft.content = (root.querySelector('#tk-content') as unknown as HTMLTextAreaElement).value.trim();
      if (!draft.subject) { toast('Başlık girin', 'error'); return; }
      if (!draft.content) { toast('Ne olduğunu kısaca yazın', 'error'); return; }
      go(catStep + 2);
    },
  });

  steps.push({
    title: 'Gönder',
    primaryLabel: 'Talebi gönder',
    body: '<h2>Son adım</h2><p class="layer-lead">Aciliyeti seçin, gerekiyorsa belge ekleyin.</p>'
      + '<div class="form-group"><label for="tk-priority">Ne kadar acil?</label>'
      + '<select id="tk-priority">' + PRIORITIES.map(([k, l]) =>
        '<option value="' + esc(k) + '">' + esc(l) + '</option>').join('') + '</select></div>'
      + '<div class="form-group"><label>Belge ekle <span class="muted">(isteğe bağlı)</span></label>'
      + '<input type="file" id="tk-file" accept=".pdf,.png,.jpg,.jpeg">'
      + '<span class="form-hint">PDF, PNG veya JPG · en fazla 10 MB</span></div>'
      + '<div class="layer-attach" id="tk-attach-state"></div>',
    onMount: (root) => {
      const sel = root.querySelector('#tk-priority') as unknown as HTMLSelectElement;
      sel.value = draft.priority;
      sel.addEventListener('change', () => { draft.priority = sel.value; });
      const file = root.querySelector('#tk-file') as unknown as HTMLInputElement;
      const state = root.querySelector('#tk-attach-state') as unknown as HTMLElement;
      file.addEventListener('change', async () => {
        const f = file.files?.[0];
        attach = null;
        state.textContent = '';
        if (!f) return;
        if (f.size > 10 * 1024 * 1024) { toast('Dosya 10 MB’ı aşıyor', 'error'); file.value = ''; return; }
        attach = { name: f.name, data: await fileToBase64(f) };
        state.innerHTML = '<i data-lucide="paperclip"></i><span class="file-name">' + esc(f.name) + '</span>';
        icons();
      });
    },
    onPrimary: async (root, go) => {
      const btn = root.querySelector('#layer-next') as unknown as HTMLButtonElement;
      btn.disabled = true; btn.textContent = 'Gönderiliyor…';
      try {
        const data = await api.post('/tickets', draft);
        if (attach) {
          try {
            await api.post('/tickets/' + data.id + '/attachment', { file_name: attach.name, file_data: attach.data });
          } catch (err: any) {
            toast('Talep açıldı ama dosya eklenemedi: ' + err.message, 'error');
          }
        }
        toast('Talep ' + data.ticket_number + ' oluşturuldu', 'success');
        go(steps.length);            // katmanı kapat
        navigate('/tickets/' + data.id);
      } catch (err: any) {
        toast(err.message, 'error');
        btn.disabled = false; btn.textContent = 'Talebi gönder';
      }
    },
  });

  openFlow(steps);
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => resolve(String(r.result).split(',')[1]);
    r.onerror = () => reject(new Error('Dosya okunamadı'));
    r.readAsDataURL(file);
  });
}

export async function renderTicketDetail(id: number) {
  const content = $('#content')!;
  setBreadcrumb([{ label: 'Panel', href: '/dashboard' }, { label: 'Destek', href: '/tickets' }, { label: 'Talep' }]);
  setHTML(content, '<div class="content-loading"><div class="spinner"></div></div>');
  try {
    const data = await api.get('/tickets/' + id);
    const t = data.ticket;
    const replies: any[] = data.replies || [];
    setBreadcrumb([{ label: 'Panel', href: '/dashboard' }, { label: 'Destek', href: '/tickets' }, { label: t.ticket_number }]);
    const closed = t.status === 'closed';
    const lastRole = replies.length ? replies[replies.length - 1].sender_role : null;
    const waitingUs = !closed && t.status !== 'resolved' && (isAdmin() ? lastRole !== 'admin' : lastRole === 'admin');

    setHTML(content, `<div>
      <div class="page-header"><div>
        <h1>${esc(t.subject)}</h1>
        <p class="page-sub"><span class="font-mono">${esc(t.ticket_number)}</span> · ${statusBadge(t.status)} · ${esc(statusLabel(t.category))}${t.priority !== 'normal' ? ' · ' + esc(statusLabel(t.priority)) : ''}${isAdmin() ? ' · ' + esc(t.client_name) : ''} · açılış ${formatDate(t.created_at)}</p></div>
        ${isAdmin() ? `<div class="page-header-actions"><select id="status-select" class="btn btn-secondary" aria-label="Durum">
          ${['open', 'in_progress', 'resolved', 'closed'].map(s => `<option value="${s}"${t.status === s ? ' selected' : ''}>${esc(statusLabel(s))}</option>`).join('')}</select></div>` : ''}
      </div>
      ${waitingUs ? `<div class="notice-bar"><i data-lucide="message-circle"></i><span>${isAdmin() ? 'Müşteri yanıt bekliyor.' : 'Leadup yanıt verdi, sizden geri dönüş bekleniyor.'}</span></div>` : ''}

      <div class="thread">${replies.map(r => {
        const staff = r.sender_role === 'admin';
        return `<div class="msg ${staff ? 'msg-staff' : 'msg-client'}">
          <div class="msg-head"><span class="msg-who">${esc(r.sender_name)}${staff ? ' <span class="chip chip-info">Leadup</span>' : ''}</span><span class="msg-time" title="${esc(formatDate(r.created_at))}">${timeAgo(r.created_at)}</span></div>
          <div class="msg-body">${esc(r.content)}</div>
          ${r.attachment_name ? `<div class="msg-file"><i data-lucide="paperclip"></i><span>${esc(r.attachment_name)}</span>${r.attachment_key && r.attachment_key.length > 100 ? `<a href="data:application/pdf;base64,${r.attachment_key}" download="${esc(r.attachment_name)}" class="btn btn-ghost btn-sm">İndir</a>` : ''}</div>` : ''}
        </div>`;
      }).join('')}</div>

      ${!closed ? `<div class="card reply-box"><div class="card-body">
        <form id="reply-form">
          <div class="form-group"><label for="reply-text" class="sr-label">Yanıtınız</label><textarea id="reply-text" name="content" rows="3" maxlength="5000" placeholder="Yanıtınızı yazın…"></textarea></div>
          <div class="reply-actions">
            <label class="btn btn-secondary btn-sm" style="cursor:pointer"><i data-lucide="paperclip"></i> PDF ekle<input type="file" id="pdf-upload" accept=".pdf" hidden></label>
            <span id="file-name" class="text-muted" style="font-size:.85rem"></span>
            <button type="submit" class="btn btn-primary" style="margin-left:auto"><i data-lucide="send"></i> Gönder</button>
          </div>
        </form></div></div>`
      : '<div class="card"><div class="card-body"><p class="text-muted" style="text-align:center;margin:0">Bu talep kapatıldı. Yeni bir konu için yeni talep açabilirsiniz.</p></div></div>'}
    </div>`);
    icons();

    let pendingFile: { name: string; data: string } | null = null;
    document.getElementById('pdf-upload')?.addEventListener('change', (e) => {
      const file = (e.target as HTMLInputElement).files?.[0];
      if (!file) return;
      if (!file.name.toLowerCase().endsWith('.pdf')) { toast('Sadece PDF eklenebilir', 'error'); return; }
      if (file.size > 10 * 1024 * 1024) { toast('Dosya çok büyük (en fazla 10MB)', 'error'); return; }
      const reader = new FileReader();
      reader.onload = () => {
        pendingFile = { name: file.name, data: (reader.result as string).split(',')[1] };
        const el = document.getElementById('file-name'); if (el) el.textContent = file.name;
      };
      reader.readAsDataURL(file);
    });
    document.getElementById('reply-form')?.addEventListener('submit', async (e) => {
      e.preventDefault();
      const text = (new FormData(e.target as HTMLFormElement).get('content') as string)?.trim();
      if (!text && !pendingFile) { toast('Yanıt yazın veya dosya ekleyin', 'error'); return; }
      const btn = (e.target as HTMLFormElement).querySelector('button[type=submit]') as HTMLButtonElement;
      btn.disabled = true;
      try {
        if (pendingFile) { await api.post('/tickets/' + id + '/attachment', { file_name: pendingFile.name, file_data: pendingFile.data }); pendingFile = null; }
        if (text) await api.post('/tickets/' + id + '/reply', { content: text });
        renderTicketDetail(id);
      } catch (err: any) { toast(err.message, 'error'); btn.disabled = false; }
    });
    document.getElementById('status-select')?.addEventListener('change', async (e) => {
      const s = (e.target as HTMLSelectElement).value;
      try { await api.put('/tickets/' + id + '/status', { status: s }); toast('Durum: ' + statusLabel(s), 'success'); renderTicketDetail(id); }
      catch (err: any) { toast(err.message, 'error'); }
    });
  } catch (err: any) { toast(err.message, 'error'); }
}
